import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {take} from "rxjs";
import {GestionErreursService} from "../../../services/gestion-erreurs.service";
import {GroovePlanApiService} from "../../../services/grooveplan-api.service";
import {AppUtilsService} from "../../../services/internals/app-utils.service";
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-base-select',
  template: ``,
  standalone: true
})
export class BaseSelectComponent extends BaseComponent implements OnInit {
  public filterForm: any

  @Output() resSelectEvent: EventEmitter<any> = new EventEmitter<any>()
  @Input() filters: any = [];
  @Input() fixedFilters: any = [];
  @Input() model: any;
  listItems: any = false;
  filtreStr: any = '';
  libelleFields: any;

  constructor(
    private repository: GroovePlanApiService,
    protected appUtils: AppUtilsService,
    protected gestionErreursService: GestionErreursService
  ) {
    super();
  }

  ngOnInit(): void {
    if(this.model) {
      this.libelleFields = this.model.getDefaultLibelleFields()
    }
    if(this.repository) {
      this.filter();
    } else {
      console.error('Erreur : Veuillez définir le repository du Select Component');
    }
  }

  filter(valueFiltreStr = '') {
    this.listItems = false;
    console.log(valueFiltreStr);
    this.filtreStr = valueFiltreStr;

    this.repository.findBy(this.mergeFilters()).then(req => {
      req.pipe(take(1)).subscribe({
        next: (res: any) => {
          this.listItems = res;
        },
        error: (err: any) => {
          this.gestionErreursService.handleError(err);
        }
      });
    });
  }

  mergeFilters(): any {
    // Commence avec les valeurs de fixedFilters
    const mergedObject = { ...this.fixedFilters };

    // Ajoute les valeurs de this.filters si elles n'existent pas déjà
    for (const key in this.filters) {
      if (!(key in mergedObject)) {
        mergedObject[key] = this.filters[key];
      }
    }

    // Ajoute les valeurs de filterForm si elles ne sont pas null/undefined et n'existent pas déjà
    if (this.filterForm) {
      Object.keys(this.filterForm.controls).forEach(key => {
        const value = this.filterForm.get(key)?.value;
        if (value !== null && value !== undefined && !(key in mergedObject)) {
          mergedObject[key] = value;
        }
      });
    }

    // Gestion du filtre textuel basé sur libelleFields
    if (this.model && this.libelleFields?.length) {
      const filterKey = this.libelleFields.map((k: any) => `${k}`).join('');
      const hasKey = (this.filters && filterKey in this.filters) || (this.fixedFilters && filterKey in this.fixedFilters);

      if (!hasKey && this.filtreStr && this.filtreStr !== '') {
        mergedObject[filterKey] = this.filtreStr;
      }
    }

    return mergedObject;
  }
  selectItem(item: any) {
    this.resSelectEvent.emit(item)
  }

  getDepValue(item: any, path: any) {
    return this.appUtils.getDepValue(item, path);
  }
}
